/**
 * @fileoverview POST handler for the "/engagement/segment_insights_actual_statistics" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryPostWebsocketAdapter } from "../reactQueryFetcherAdapters";
import { engagementSegmentInsightsActualStatisticsCacheKeys } from "./constants";
import type {
  PostEngagementSegmentInsightsActualStatisticsPayload,
  PostEngagementSegmentInsightsActualStatisticsResults,
} from "./types";
import { isActualSegmentInsightsStats } from "./validators";

export const postEngagementSegmentInsightsActualStatistics = reactQueryPostWebsocketAdapter(
  engagementSegmentInsightsActualStatisticsCacheKeys,
  async (
    signal,
    { appGroupId, segmentId, jobToken, ...params }: PostEngagementSegmentInsightsActualStatisticsPayload
  ): Promise<PostEngagementSegmentInsightsActualStatisticsResults> => {
    const payload = {
      app_group_id: appGroupId,
      segment_id: segmentId,
      job_token: jobToken,
      ...params,
    };
    return await fetch("/engagement/segment_insights_actual_statistics", "POST", payload, { signal });
  },
  isActualSegmentInsightsStats
);
